import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { databaseId, db, functions } from '@/lib/firebase';

export interface RequestDataExportResponse {
  success: true;
}

export interface RequestDeleteAccountResponse {
  success: true;
}

const requestDataExportFn = httpsCallable<{ databaseId: string }, RequestDataExportResponse>(
  functions,
  'requestDataExport'
);

const requestDeleteAccountFn = httpsCallable<
  { databaseId: string; reason?: string },
  RequestDeleteAccountResponse
>(functions, 'requestDeleteAccount');

export const gdprService = {
  async requestDataExport(): Promise<void> {
    await requestDataExportFn({ databaseId });
  },
  async requestAccountDeletion(reason?: string): Promise<void> {
    const trimmed = reason?.trim();
    await requestDeleteAccountFn({ databaseId, ...(trimmed ? { reason: trimmed } : {}) });
  },
  async hasPendingDataExport(uid: string): Promise<boolean> {
    const q = query(
      collection(db, 'users', uid, 'dataExportRequests'),
      where('status', '==', 'pending'),
      limit(1)
    );
    try {
      const snap = await getDocs(q);
      return !snap.empty;
    } catch (err) {
      console.error('Failed to check pending data export:', err);
      return false;
    }
  },
  async hasPendingDeletion(uid: string): Promise<boolean> {
    const q = query(
      collection(db, 'users', uid, 'deletionRequests'),
      where('status', '==', 'pending'),
      limit(1)
    );
    try {
      const snap = await getDocs(q);
      return !snap.empty;
    } catch (err) {
      console.error('Failed to check pending deletion:', err);
      return false;
    }
  },
};
